import React from "react";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
  useLenis();
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Manifesto />
        <Services />
        <Contact />
      </main>
      <Footer />
      <Toaster richColors position="bottom-right" />
    </div>
  );
}
